<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  @import "style/base.css";
  html, body{
  }
  #app{
  }
</style>



// WEBPACK FOOTER //
// src/App.vue